import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'

import Button from '@material-ui/core/Button'

/**
 * <CommentShowDialog show onCommentShow = {show, comment} onCancel = {} />
 */

class CommentShowDialog extends Component {

	state = {
		comment: ""
	}

	componentDidMount() {
		this.setState({
			comment: this.props.show.comment
		})
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Комментарий к шоу
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TextField
					label = "Комментарий к шоу"
					multiline
					rowsMax = "8"
					value = {this.state.comment}
					onChange = {e => {
						this.setState({
							comment: e.target.value
						})
					}}
					margin = "normal"
					variant = "outlined"
				/>

			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCommentShow === "function") {
							this.props.onCommentShow(this.props.show, this.state.comment)
						}
					}}
				>Сохарнить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default CommentShowDialog
